import React, { useState, useEffect } from 'react';
import NxPage from './nx/NxPage';
import { homeHtml } from './nx/pages';
import PartnerLogos from './nx/PartnerLogos';

const HOME_SLOTS = { partners: <PartnerLogos /> };

export default function LandingPage({ 
  isDark, 
  setIsDark, 
  onNavigateToAbout,
  onNavigateToCommunity,
  onNavigateToAIConsulting,
  onNavigate, // ADD THIS - receives handleNavigation from App.js
  targetSection,
  setTargetSection,
  activeSection,
  setActiveSection
}) {
  const [parallaxOffset, setParallaxOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // "Partner with Imfuyo" and similar buttons ask for the contact section
  useEffect(() => {
    if (targetSection !== 'contact') return;
    const timer = setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (setTargetSection) setTargetSection(null);
    }, 150);
    return () => clearTimeout(timer);
  }, [targetSection, setTargetSection]);

  // Parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 10;
      const y = (e.clientY / window.innerHeight) * 10;
      setParallaxOffset({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div 
      className={`relative transition-colors duration-700 ${isDark ? 'bg-gray-900' : 'bg-white'}`}
    >
      <NxPage html={homeHtml} slots={HOME_SLOTS} onNavigate={onNavigate} onRegister={() => onNavigate && onNavigate('mbuziplus')} scrollTop={false} />

      {/* Global Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap');
        
        html {
          scroll-behavior: smooth;
        }

        .bg-green-background {
          background: linear-gradient(
            135deg,
            #285020 0%,
            #285020 50%,
            #285020 100%
          );
        }

        @keyframes blink {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
        }

        .animate-blink {
          animation: blink 1s step-start infinite;
        }

        @keyframes drift {
          0%, 100% {
            transform: translate(0, 0);
          }
          25% {
            transform: translate(30px, -30px);
          }
          50% {
            transform: translate(0, -50px);
          }
          75% {
            transform: translate(-30px, -30px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.35;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.05);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @media (max-width: 640px) {
          button, a {
            min-height: 44px;
            min-width: 44px;
          }
        }

        ::-webkit-scrollbar {
          width: 10px;
        }

        ::-webkit-scrollbar-track {
          background: ${isDark ? '#1f2937' : '#f3f4f6'};
        }

        ::-webkit-scrollbar-thumb {
          background: #285020;
          border-radius: 5px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #285020;
        }
      `}</style>
    </div>
  );
}